import React from 'react';
import {Bar} from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';

const VolumeChart = (props) => {
    const {activeEntityStats} = props;

    const convertDateArr = (dateArr) => {
        let dateArrClone = [...dateArr];
        let initialMonth = dateArrClone[0].split(' ')[1];
        dateArrClone.forEach((item, index) => {
            let singleDateAsArray = item.split(' ');
            if(singleDateAsArray[0].length === 1) singleDateAsArray[0] = `0${singleDateAsArray[0]}`;
            dateArrClone[index] = singleDateAsArray[0];
            if(index === 0) {
                dateArrClone[index] = singleDateAsArray[1];
            } else if(index % 2 === 0) {
                if(singleDateAsArray[1] !== initialMonth) {
                    dateArrClone[index] = singleDateAsArray[1];
                    initialMonth = singleDateAsArray[1];
                } else {
                    dateArrClone[index] = singleDateAsArray[0];
                }
            } else {
                dateArrClone[index] = '';
            }
        });
        return dateArrClone;
    };

    let stackKey = 'main';
    const data = {
        labels: convertDateArr(activeEntityStats.chartDates),
        datasets: [
            {
                data: activeEntityStats.countVolume.map(obj => obj.social),
                stack: stackKey,
                label: 'Social Media',
                backgroundColor: '#4472c4',
                // backgroundColor: 'rgba(37,102,166,.5)',
                // borderColor: 'rgba(37,102,166,1)',
                // borderWidth: 1,
                // hoverBackgroundColor: 'rgba(37,102,166,0.9)',
                // hoverBorderColor: 'rgba(37,102,166,1)',
            },
            {
                data: activeEntityStats.countVolume.map(obj => obj.news),
                stack: stackKey,
                label: 'News',
                backgroundColor: '#ed7d32',
                // backgroundColor: 'rgba(37,102,166,.5)',
                // borderColor: 'rgba(37,102,166,1)',
                // borderWidth: 1,
                // hoverBackgroundColor: 'rgba(37,102,166,0.9)',
                // hoverBorderColor: 'rgba(37,102,166,1)',
            }
        ],
    };

    return (
        <div className="d-flex flex-column" style={{flex: 1, paddingTop: '15px'}}>
            <div className="entity-chart-title">Volume per Day</div>
            <div style={{
                maxHeight: '300px',
                padding: '10px 0',
                marginBottom: '10px',
                flex: 1,
            }}>
                <Bar
                    data={data}
                    height={300}
                    responsive={false}
                    options={{
                        legend: {
                            // display: false,
                        },
                        tooltips: {
                            callbacks: {
                                title: tooltipItem => activeEntityStats.chartDates[tooltipItem[0].index],
                            },
                        },
                        maintainAspectRatio: false,
                        scales: {
                            xAxes: [
                                {
                                    ticks: {
                                        autoSkip: false,
                                        maxTicksLimit: 15,
                                        stepSize: 1,
                                    },
                                },
                            ],
                            yAxes: [
                                {
                                    ticks: {
                                        beginAtZero: true,
                                    },
                                },
                            ],
                        },
                        plugins: {
                            datalabels: {
                                display: true,
                                color: 'white',
                                borderRadius: 6,
                                font: {
                                    size: 12,
                                },
                                formatter: function(value) {
                                    if(value > 0) {
                                        return value;
                                    } else {
                                        return null;
                                    }
                                },
                            },
                        },
                    }}
                />
            </div>
        </div>
    );
};

export default VolumeChart;
